import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tabs, Table, Tooltip, DatePicker } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import axios from 'axios';
import { maskDate } from "../utils/Masker";
import moment from "moment-timezone";
import numeral from "numeral";
import { getUsuario, getTemPermissao } from "../utils/LoginManager";

const { Item: ItemForm } = Form;
const TabPane = Tabs.TabPane;
const { Column } = Table;
const ButtonGroup = Button.Group;


export const OPCOES_TIPO = [
  { key: 'P', label: 'PEDIDO' },
  { key: 'O', label: 'ORÇAMENTO' },
]

const dateFormat = 'DD/MM/YYYY';

function disabledDate(current) {
  return current && current.valueOf() > Date.now();
}


export default class EntregaEditarForm extends Component {
  state = {
    registro: {
      ven_idf: 0,
      ven_numero: '',
      ven_dt_venda: moment().format('DD/MM/YYYY'),
      ven_obs: '',
      ven_qtde_itens: 0,
      ven_vlr_itens: 0,
      ven_vlr_acres: 0,
      ven_vlr_desc: 0,
      ven_vlr_total: 0,
      ven_tipo_venda: { key: 'P' },
      ven_pessoa: { key: '0' },
      ven_usuario: { key: '0' },
      ven_cond_pagto: { key: '0' },
      ven_latitude: 0,
      ven_longitude: 0,
    },
    modalProdutoVisible: false,
    modalEntregaVisible: false,
    modalParcelaVisible: false,
    modalListaVisible: false,

    carregandoForm: false,
    editando: false,
    visualizando: false,

    activeKey: "dados",

    listaProdutos: [],
    listaEntregas: [],
    vlrTotalParc: 0,
    vlrDifParc: 0,
  };


  componentDidUpdate(propsAnterior) {
    // console.log('EntregaForm.componentDidUpdate---------------------------------: ', this.props);
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        ven_idf: this.props.registroSelecionado[0].ven_idf,
        listaRegistros: this.props.registroSelecionado,
      }, () => {
        this.buscaStatus();
      });
    }
  }

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({
      usuario,
    });
  }






  renderValor = (ven_vlr_total, registro) => {
    return (
      <span> {numeral(parseFloat(ven_vlr_total)).format('0,000.00')} </span>
    );
  };


  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      <span></span>
    }
  }


  renderDataEntrega = (data, registro) => {
    const vie_data_entrega = data ? moment(data).format('DD/MM/YYYY') : null;
    return (
      <Col xs={24} style={{ marginTop: -10, marginBottom: -30, marginLeft: -10, marginRight: -10 }}>
        <DatePicker
          size="small"
          defaultValue={vie_data_entrega ? moment(vie_data_entrega, dateFormat) : null}
          format={dateFormat}
          disabledDate={disabledDate}
          onChange={(value, date) => {
            const dt = date ? moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';
            registro['vie_data_entrega'] = dt;
          }}
        />
      </Col>
    )
  }






  buscaStatus = (value) => {
    this.setState({ statusSelect: [] })
    axios.get('/statusEntrega/lista', {
    }).then(response => {
      const { data } = response;
      const statusSelect = data.map(regList => {
        return {
          key: regList.se_idf,
          label: regList.se_descricao,
        }
      });
      this.setState({
        statusSelect,
      })
    }).catch(error => {
      console.error(error.response);
    })
  }

  renderStatus = (sit, registro) => {
    const vie_situacao = {
      key: sit,
      label: registro.se_descricao,
    }
    return (
      <Col xs={24} style={{ marginTop: -5, marginBottom: -30 }}>
        <InputForm
          type="select"
          id="vie_situacao"
          ref="vie_situacao"
          value={vie_situacao}
          placeholder="Status da Entrega"
          onChange={situacao => this.onVerificaStatus(registro, situacao)}
          data={this.state.statusSelect}
          validator={value => Boolean(value)}
          style={{ width: 150 }}
        />
      </Col>
    );
  };

  onVerificaStatus = (registro, event) => {
    this.onChangeStatus(registro, event, '')
  }

  onChangeStatus = (registro, event, justificativa) => {
    justificativa = justificativa ? justificativa : 'X';
    this.setState({ carregando: true })
    axios.
      put(`/vendas/mudaSituacaoEntrega/${registro.ven_idf}/${registro.vie_item}/${registro.vie_seq}/${event.target.value.key}/${justificativa}`)
      .then(response => {
        registro.vie_situacao = event.target.value.key;
        this.setState({
          listaRegistros: this.state.listaRegistros.concat([]),
          justificativa: '',
          registro: '',
          eventStatus: '',
          carregando: false
        }, () => {
          // this.getListaRegistros();
        })
      }).catch(error => {
        console.error(error.response);
        this.setState({ carregando: false })
      })
  };




  renderQtdes = (qtde, registro) => {
    return (
      <Col xs={24} style={{ marginTop: -5, marginBottom: -20 }}>
        <Col xs={6} style={{ marginTop: 15, marginLeft: 0, marginRight: 0 }}>
          <Button className="botoesModalFormEditar" size="small" onClick={() => this.onQtdeMenosClick(registro)} icon="minus" />
        </Col>
        <Col xs={12} style={{ marginTop: 8, marginLeft: 0, marginRight: 0 }}>
          <InputForm
            type="number"
            id="qtde"
            ref="qtde"
            value={registro.qtde}
            onChange={(value) => {
              registro.qtde = value.target.value;
              this.forceUpdate();
            }}
          />
        </Col>
        <Col xs={6} style={{ marginTop: 15, marginLeft: 0, marginRight: 0 }}>
          <Button className="botoesModalFormEditar" size="small" onClick={() => this.onQtdeMaisClick(registro)} icon="plus" />
        </Col>
      </Col>
    );
  };

  onQtdeMaisClick = (registro) => {
    // console.log('onQtdeMenosClick: ', this.registro);
    if (registro.qtde < registro.vie_qtde) {
      registro.qtde = registro.qtde + 1;
      this.forceUpdate();
    }
  };

  onQtdeMenosClick = (registro) => {
    // console.log('onQtdeMenosClick: ', this.registro);
    if (registro.qtde > 1) {
      registro.qtde = registro.qtde - 1;
      this.forceUpdate();
    }
  }



  renderAcoesParcelas = (registro) => {
    return (
      <ButtonGroup size="small">
        <Tooltip title="Excluir" placement="top">
          <Button className="botoesModalFormExcluir" onClick={() => this.onExcluirClick(registro)} icon="delete" />
        </Tooltip>
      </ButtonGroup>
    );
  };


  onOK = () => {
    // console.log('onOK: ', this.state);

    for (var x in this.state.listaRegistros) {
      if (this.state.listaRegistros[x].qtde > this.state.listaRegistros[x].vie_qtde) {
        Modal.warning({ title: 'Aviso!', content: 'Quantidade de entrega do produto ' + this.state.listaRegistros[x].prod_codigo + ' é maior que disponível' });
        return;
      }
      if (this.state.listaRegistros[x].qtde < 1) {
        Modal.warning({ title: 'Aviso!', content: 'Quantidade de entrega do produto ' + this.state.listaRegistros[x].prod_codigo + ' não pode ser menor que 1' });
        return;
      }
    };

    // return;

    const registro = {
      ven_idf: this.state.ven_idf,
      listaEntregas: this.state.listaRegistros,
    };

    this.props.onSalvarClick(registro);
  };


  onExcluirClick = (reg) => {
    if ((this.state.listaRegistros) && (this.state.listaRegistros.length > 0)) {
      const prod = reg.vie_item;
      var ind = 0
      for (var y in this.state.listaRegistros) {
        if (prod === this.state.listaRegistros[y].vie_item) {
          ind++;
        }
      }
    }

    if (ind > 1) {
      // console.log('onExcluirClick1: ', this.state);
      Modal.confirm({
        title: 'Confirmação de Exclusão',
        content: `Deseja excluir esta Entrega?`,
        okText: 'Sim',
        cancelText: 'Não',
        onOk: () => {
          const listaRegistros = [...this.state.listaRegistros];
          const index = listaRegistros.findIndex(registro => registro.vie_item === reg.vie_item && registro.vie_item_seq === reg.vie_item_seq);
          listaRegistros.splice(index, 1);

          // console.log('onExcluirClick2: ', this.state);
          const prod = reg.vie_item;
          var ind = 0
          for (var y in listaRegistros) {
            if (prod === listaRegistros[y].vie_item) {
              ind++;
            }
          }
          if (ind === 1) {
            for (var y in listaRegistros) {
              if (prod === listaRegistros[y].vie_item) {
                listaRegistros[y].qtde = listaRegistros[y].vi_qtde;
                listaRegistros[y].vie_qtde = listaRegistros[y].vi_qtde;
              }
            }
          }

          this.setState({
            listaRegistros,
          });
        }
      })
    }
  }





  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------



  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { carregandoForm, listaRegistros } = this.state;
    const { } = this.state.registro;

    // console.log('EntregaForm.this.state: ', this.state);

    return (
      <Modal
        title={"Entregas do Pedido"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"70%"}
        style={{ top: 10 }}
      >

        <div style={{ height: 450 }}>
          <Table
            loading={{
              spinning: carregandoForm,
              tip: 'Carregando. Aguarde...',
              size: "large"
            }}
            dataSource={listaRegistros}
            pagination={false}
            // scroll={{ x: 600, y: 300 }}
            rowKey={(registro => registro.ven_idf + '_' + registro.vie_item + '_' + registro.vie_seq)}
          // onRow={record => ({
          //   style: { backgroundColor: record.se_abrev === 'ENT' || record.se_abrev === null ? '#7cd4a5' : '' }
          //   // style: { backgroundColor: record.se_abrev === 'ENT' || record.se_abrev === null ? '#7cd4a5' : '#e50000' }
          // })}
          >
            <Column
              key="prod_codigo"
              dataIndex="prod_codigo"
              title="Produto"
              render={this.renderCliente}
              width={"10%"}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="prod_descricao"
              dataIndex="prod_descricao"
              title="Descrição do Produto"
              render={this.renderCliente}
              width={"30%"}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="vie_data"
              dataIndex="vie_data"
              title="Data Prevista"
              render={this.renderData}
              width={"15%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="vie_data_entrega"
              dataIndex="vie_data_entrega"
              title="Data Entrega"
              render={this.renderDataEntrega}
              width={"20%"}
              align="left"
              className="listaCadastro"
            />
            <Column
              key="vie_qtde"
              dataIndex="vie_qtde"
              title="Qtde Entrega"
              render={this.renderQtdes}
              width={"30%"}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="vie_situacao"
              dataIndex="vie_situacao"
              title="Status"
              render={this.renderStatus}
              width={'10%'}
              align="center"
              className="listaCadastro"
            />
            <Column
              key="acoes"
              title=""
              render={this.renderAcoesParcelas}
              width={'5%'}
              align="center"
              className="listaCadastro"
            />
          </Table>
        </div>


        <div>
          <div className="divider-form" />
          <ItemForm>
            <Row>
              <Col xs={24}>
                <Button
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onOK}
                  className="botoesModalForm2x"
                >
                  Salvar Entregas
                </Button>
                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="botoesModalFecharForm"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>

      </Modal >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EntregaForm.js